package com.exura.features.plandefinition.data.remote.dto.series

import com.exura.features.firebase.data.remote.dto.SerializableDto
import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType
import kotlinx.serialization.Serializable

/**
 * Base Data Transfer Object for all series types.
 * Implements SerializableDto for Firebase storage compatibility.
 */
@Serializable
abstract class BaseSeriesDto : SerializableDto {
    abstract val name: String
    abstract val description: String
    abstract val seriesType: SeriesSpawnType
    abstract val durationInDays: Int?
    abstract val imageUrl: String?
}
